// src/components/qr/PreviewPanel.tsx
import React from 'react';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
export const PreviewPanel = ({ url, onUrlChange, ready, canvasRef, previewSize, onPreviewSizeChange, }) => {
    return (<div className="flex flex-col gap-4">
            <div className="space-y-1.5">
                <label htmlFor="qr-url" className="text-xs font-medium text-muted-foreground">
                    URL or Text
                </label>
                <Input id="qr-url" value={url} onChange={(e) => onUrlChange(e.target.value)} placeholder="https://…" className="font-mono text-sm"/>
            </div>

            {/* ✅ preview size control */}
            <div className="space-y-1.5">
                <label htmlFor="qr-size" className="text-xs font-medium text-muted-foreground">
                    Preview size (px)
                </label>
                <Input id="qr-size" type="number" inputMode="numeric" value={previewSize} min={120} max={600} step={10} onChange={(e) => onPreviewSizeChange(Number(e.target.value))} className="font-mono text-sm"/>
            </div>

            <div className="relative flex justify-center">
                <canvas ref={canvasRef} className="rounded-xl border border-border shadow-sm bg-white max-w-full" aria-label="QR code preview"/>
                {!ready && (<div className="absolute inset-0 flex items-center justify-center rounded-xl bg-muted/60">
                        <p className="text-xs text-muted-foreground">Enter a URL to preview</p>
                    </div>)}
            </div>

            <div className="flex justify-center">
                <Badge variant={ready ? 'default' : 'secondary'} aria-live="polite" className="text-xs">
                    {ready ? 'QR Ready' : 'No Content'}
                </Badge>
            </div>
        </div>);
};
PreviewPanel.displayName = 'PreviewPanel';
